const a={mc:"Mastercard",visa:"Visa"};export{a as SchemeNames};
